<template>
  <div>
      <img v-if='asset.type !== "pack"' :src='imageUrl' class="object-contain h-full" />
      <sprite-view v-else :sprite='dummySprite' class="object-contain h-full" />
  </div>
</template>
<script>
import SpriteView from '@/edit/atoms/SpriteView.vue';
export default {
  inject:['api'],
  props:{
    asset: {
      type: Object,
      required:true
    },
  },
  components:{
    SpriteView
  },
  computed:{
    imageUrl() {
      if (this.asset.type === 'image') {
        return this.api.makeImageUrlEditor(this.asset.data.id);
      } else if (this.asset.type === 'animation') {
        return this.api.makeAnimationThumbnailUrl(this.asset.data.thumbnail);
      } else if (this.asset.type === 'pack') {
        return this.api.makeImageUrlEditor('placeholder.png');
      }
      return this.api.makeImageUrlEditor('placeholder.png');
    },
    dummySprite() {
      if (this.asset.type !== 'pack') {
        return {};
      } else {
        const data = this.asset.data;
        const {image,spritesheet} = data;
        console.log('asset', data);
        return {
          atlas:spritesheet.id,
          texture:image.name,
          sprite:image.name
        }
      }
    }
  }
}
</script>
